import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrinter2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="printer-2, print"><path d="M17.5 11.25H21.25V3.75H2.75V11.25H6.5" stroke="currentColor" strokeWidth="1.5"/><path d="M6.75 7.75H17.25V20.25H6.75V7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M10 11.75H14" stroke="currentColor" strokeWidth="1.5"/><path d="M10 15.75H12.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPrinter2;
